<ng-container [formGroup]="customFormData">
  <div [id]="controlName"></div>
  <p-autoComplete
    #pac
    appRegisterValidator
    [formControlName]="customControlName"
    [field]="searchBy"
    [suggestions]="suggestedList"
    [placeholder]="placeholder || 'form.placeholder.' + controlName | translate"
    [inputId]="'pac-' + controlName"
    [delay]="delay"
    (onFocus)="showPanel(pac, true)"
    (onSelect)="updateAddresEventAutoComplete($event)"
    (onKeyUp)="showPanel(pac)"
    (onBlur)="checkControl()"
    [ngClass]="{
      'mu-auto-complete-error': error,
      'mu-auto-complete-empty': !suggestedList || suggestedList?.length < 1,
      'mu-form-editable-mask': editableMask
    }"
    (click)="editableMask = false"
  >
    <ng-template let-address pTemplate="item">
      <div
        class="mu-form-address-item p-grid"
        [ngClass]="{
          'mu-form-address-item-loading': address?.type === addressType.LOADING,
          'mu-form-address-item-active': address?.type === addressType.CURRENT
        }"
      >
        <div class="mu-form-address-item-icon mu-form-address-item-cell">
          <i [class]="address?.iconClass" aria-hidden="true"></i>
        </div>
        <div class="mu-form-address-item-cell">
          <div class="p-grid">
            <ng-container
              [ngTemplateOutlet]="[addressType.SUGGESTED, addressType.CURRENT].includes(address?.type) ? addressTemplate : textTemplate"
              [ngTemplateOutletContext]="{ address: address }"
            >
            </ng-container>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template let-address pTemplate="selectedItem"></ng-template>
    <ng-template let-address pTemplate="empty"></ng-template>
  </p-autoComplete>
  <ng-container *ngIf="!showDeleteFieldAddress; else blockIcons">
    <em
      class="mu-icon mu-icon-star mu-form-address-item-favorite"
      [ngClass]="{ 'mu-form-address-item-favorite-active': isAddressFavorite }"
      (click)="createFavoriteAddress()"
      [pTooltip]="'form.label.addToFavorite' | translate"
      [tooltipPosition]="'top'"
      [tooltipDisabled]="isAddressFavorite"
      *ngIf="createFavoritePermission"
    ></em>
  </ng-container>
  <ng-template #blockIcons>
    <em
      class="mu-icon mu-icon-failed mu-form-address-item-erase"
      (click)="deleteFieldAddress()"
      [pTooltip]="'form.label.removeAddressExpress' | translate"
      [tooltipPosition]="'top'"
      [tooltipDisabled]="hideTooltip"
    ></em>
  </ng-template>
</ng-container>

<ng-template #addressTemplate let-address="address">
  <div class="p-col-12 mu-form-address-item-title">
    {{ address?.address + '' !== 'undefined' ? address?.address : '' }}
  </div>
  <div class="p-col-12 mu-form-address-item-text">
    {{ (address?.text + '' !== 'undefined' ? address?.text : '') | translate }}
  </div>
</ng-template>

<ng-template #textTemplate let-address="address">
  <div class="p-col-12 mu-form-address-item-title">
    {{ (address?.text + '' !== 'undefined' ? address?.text : '') | translate }}
  </div>
  <div class="p-col-12 mu-form-address-item-text">
    {{ (address?.address + '' !== 'undefined' ? address?.address : '') + (address?.cityName ? ', ' + address?.cityName : '') }}
  </div>
</ng-template>
